import { keys, filter, includes, isEqual, upperFirst, reduce } from 'libraries/lodash'
import { debounceTime, startWith, map, distinctUntilChanged } from 'rxjs/operators'
import { Resize } from 'libraries/front-end-core/services/WindowService'
import {
  PAGE_MAX_WIDTH,
  TABLET_MAX_WIDTH,
  MOBILE_MAX_WIDTH,
  DESKTOP_MIN_WIDTH,
  LARGE_DESKTOP_MIN_WIDTH
} from 'styles/config/config.js'

const mqMax = width => `screen and (max-width: ${width}px)`
const mqMin = width => `screen and (min-width: ${width}px)`

export const mediaQueries = {
  tablet: mqMax(TABLET_MAX_WIDTH),
  mobile: mqMax(MOBILE_MAX_WIDTH),
  desktop: mqMin(DESKTOP_MIN_WIDTH),
  desktopFullscreen: mqMin(PAGE_MAX_WIDTH),
  fullscreen: mqMax(PAGE_MAX_WIDTH),
  largeDesktop: mqMin(LARGE_DESKTOP_MIN_WIDTH)
}

const getMatchedMediaQueries = () =>
  filter(keys(mediaQueries), key => {
    return window.matchMedia(mediaQueries[key]).matches
  })

export const Resized = Resize.pipe(
  debounceTime(10),
  startWith({ windowWidth: window.innerWidth, windowHeight: window.innerHeight }),
  map(() => ({ windowWidth: window.innerWidth, windowHeight: window.innerHeight }))
)

export const WidthResized = Resized.pipe(
  map(({ windowWidth }) => windowWidth),
  distinctUntilChanged(isEqual)
)

export const MediaChanged = Resized.pipe(
  map(getMatchedMediaQueries),
  distinctUntilChanged(isEqual)
)

// e.g. Media.Tablet emits true or false when window resized
export const Media = reduce(
  keys(mediaQueries),
  (acc, key) => {
    acc[upperFirst(key)] = MediaChanged.pipe(map(media => includes(media, key)))
    return acc
  },
  {}
)

export const getMinimumSwipeThreshold = windowWidth => {
  if (windowWidth < MOBILE_MAX_WIDTH) {
    return 50
  } else if (windowWidth < TABLET_MAX_WIDTH) {
    return 30
  } else {
    return 25
  }
}
